<template>
  <div v-if="workflowDefinition">
    <!-- Vue mount component but props is undefined -->
    <RawJsonToggler :json="workflowDefinition" />
    <!-- Workflow Definition -->
    <h1>{{ workflowDefinition.name }}</h1>
    <!-- Actions -->
    <Fieldset legend="Actions">
      <router-link
        v-if="!readOnly"
        tag="button"
        :to="{
          name: 'workflowDefinitionEdit',
          params: {
            workflowDefinitionName: workflowDefinitionName,
            workflowDefinitionVersion: workflowDefinitionVersion
          }
        }"
      >
        Edit
      </router-link>
      <button
        v-if="!readOnly"
        @click="
          removeWorkflowDefinition([
            workflowDefinitionName,
            workflowDefinitionVersion
          ])
        "
      >
        Remove
      </button>
    </Fieldset>
    <DataList :data="workflowDefinition" :attributes="attributes" />
    <!-- Tasks -->
    <DataTable
      caption="Tasks"
      :rowKeys="['name']"
      :rows="workflowDefinition.tasks"
      :actions="[]"
      :columns="[
        { name: 'name', type: 'text' },
        { name: 'taskReferenceName', type: 'text' },
        { name: 'type', type: 'text' }
      ]"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'
import DataList from '@/components/DataList.vue'
import Fieldset from '@/components/Fieldset.vue'
import RawJsonToggler from '@/components/RawJsonToggler.vue'

export default {
  name: 'WorkflowDefinition',
  props: ['workflowDefinitionName', 'workflowDefinitionVersion'],
  data() {
    return {
      attributes: [
        { name: 'name', type: 'text' },
        { name: 'description', type: 'text' },
        { name: 'version', type: 'text' },
        { name: 'createTime', type: 'date' },
        { name: 'updateTime', type: 'date' }
      ]
    }
  },
  computed: mapState(['workflowDefinition', 'readOnly']),
  methods: {
    ...mapActions(['getWorkflowDefinition', 'removeWorkflowDefinition'])
  },
  created() {
    this.getWorkflowDefinition([
      this.workflowDefinitionName,
      this.workflowDefinitionVersion
    ])
  },
  watch: {
    workflowDefinitionName: function() {
      this.getWorkflowDefinition([
        this.workflowDefinitionName,
        this.workflowDefinitionVersion
      ])
    },
    workflowDefinitionVersion: function() {
      this.getWorkflowDefinition([
        this.workflowDefinitionName,
        this.workflowDefinitionVersion
      ])
    }
  },
  components: {
    DataTable,
    DataList,
    Fieldset,
    RawJsonToggler
  }
}
</script>
